import { Box, Paper, Typography, IconButton } from "@mui/material";
import FindInPageOutlined from "@mui/icons-material/FindInPageOutlined";
import makeStyles from '@mui/styles/makeStyles';
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade";
import { modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store";
import { ListagemItem } from "src/components/projetos/types";
import { VALOR_MULTIPLO_CABO } from "src/components/projetos/constants";
import { ID_CABO } from "src/components/componentes/types";
import { MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants";

export interface AccessoriesListMobileProps {
  acessorios: ListagemItem[];
  checkError: (id: number, qtd: number) => boolean;
  handleChangeQuantity: (id: number, value: string) => void;
  handleOpenModalDadosTecnicos?: ({ detalhesComponenteId }: { detalhesComponenteId?: number }) => void;
}

const useStyles = makeStyles({
  container: {
    width: '100%'
  },

  card: {
    padding: 15,
    borderRadius: 12,
    marginBottom: 25,
  },

  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    position: "relative",
    paddingLeft: 5
  },

  componenteInfo: {
    flex: 1,
    textAlign: "left",
  },

  infoTexto: {
    marginBlock: 3
  },

  attention: {
    color: "#c47a00",
    fontWeight: 600,
  },

  inputQuantidade: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    position: "relative",
    left: "-20px"
  },

  detailsButton: {
    textAlign: "right",
    position: "relative",
    top: 3,
  },

  rowBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 15
  }
});

export default function AcessoriosListMobile({
  checkError,
  acessorios,
  handleChangeQuantity,
  handleOpenModalDadosTecnicos,
}: AccessoriesListMobileProps) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {acessorios?.map((row) => {
        return (
          <Paper key={row.componente_id} className={classes.card} elevation={1}>
            <Box className={classes.cardHeader}>
              <Box className={classes.componenteInfo}>
                <Typography variant="body1" style={{ fontWeight: 600 }} className={classes.infoTexto}>
                  {row.nome}
                </Typography>

                {row.descricao && (
                  <Typography variant='body2' color='textSecondary' className={classes.infoTexto}>
                    <span className={classes.attention}>Informações</span>: {row.descricao}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box className={classes.rowBox}>
              <Box className={classes.inputQuantidade}>
                <InputQuantidade
                  value={row.quantidade || 0}
                  hasError={checkError(row.categoria_componentes_id, row.quantidade)}
                  multiple={row.categoria_componentes_id === ID_CABO ? VALOR_MULTIPLO_CABO : 1}
                  onChange={(v: any) => handleChangeQuantity(row.componente_id, v)}
                />
              </Box>

              <Box className={classes.detailsButton}>
                <IconButton
                  size="large"
                  onClick={() => {
                    if (handleOpenModalDadosTecnicos) {
                      handleOpenModalDadosTecnicos({ detalhesComponenteId: row.componente_id })
                    } else {
                      modalComponentesDetalhesData$.next(row.componente_id)
                    }
                  }}
                >
                  <FindInPageOutlined htmlColor="black" fontSize="large" />
                </IconButton>
              </Box>
            </Box>
            <Box textAlign="left" marginTop={1} marginLeft={1}>
              {row.categoria_componentes_id === ID_CABO && checkError(row.categoria_componentes_id, row.quantidade) && (
                <span style={{ color: "#b91322" }}>{MENSAGEM_QUANTIDADE_CABOS_INVALIDA}</span>
              )}
            </Box>
          </Paper>
        );}
      )}
    </Box>
  );
}